// Entry point for the build script in your package.json
require("turbolinks-csp")
require("@rails/activestorage").start()
require("./channels")
require('./mobile_apps/turbolinks_adapter')

import "./controllers"
import Rails from '@rails/ujs'

Turbolinks.start()
Rails.start()

document.addEventListener('touchstart', function() {}, { passive: true });
